export const FIELD_FILTER_MAP = {
  payrollTypes: "earnings",
  employmentType: "employment",
  payItems: "additional",
  seperationType: "seperationType",
  suspension: "suspension",
};

export const PAY_ITEMS = {
  BACK_PAY: "Back Pay",
  ADDENDUM_BACK_PAY: "Addendum Back Pay",
};

export const BACK_PAY_ITEM_VALUES = [PAY_ITEMS.BACK_PAY];

export const ADDENDUM_BACK_PAY_ITEM_VALUES = [PAY_ITEMS.ADDENDUM_BACK_PAY];

export const isBackPayItem = (payItem) => payItem === PAY_ITEMS.BACK_PAY;

export const isAddendumBackPayItem = (payItem) =>
  payItem === PAY_ITEMS.ADDENDUM_BACK_PAY;
